module.exports = __webpack_public_path__ + "img/chat-widget.df16c782.png";